import { useEffect, useRef, useState } from 'react'
import styles from './TrustBar.module.css'

// Decorative separator — a thin dot
const Dot = () => <span className={styles.dot} aria-hidden="true">·</span>

const trustItems = [
  { text: 'Context before suggestion', depth: 0.5 },
  { text: 'Precise, not just plausible', depth: 0.8 },
  { text: 'Edits that fit the logic', depth: 0.6 },
  { text: 'Built for careful technical work', depth: 0.7 },
  { text: 'No confident wrong answers', depth: 0.9 },
  { text: 'The gap between intent and file, closed', depth: 0.4 },
]

const TrustBar = () => {
  const trackRef = useRef<HTMLDivElement>(null)
  const sectionRef = useRef<HTMLDivElement>(null)
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const track = trackRef.current
    if (!track) return

    // Duplicate items for seamless loop
    const items = Array.from(track.children)
    items.forEach(item => {
      const clone = item.cloneNode(true)
      track.appendChild(clone)
    })
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return

      const rect = sectionRef.current.getBoundingClientRect()
      const sectionTop = rect.top
      const sectionHeight = rect.height
      const windowHeight = window.innerHeight

      // Calculate parallax only when section is in view
      if (sectionTop < windowHeight && sectionTop + sectionHeight > 0) {
        const scrollProgress = (windowHeight - sectionTop) / (windowHeight + sectionHeight)
        setScrollY(Math.min(1, Math.max(0, scrollProgress)))
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll() // Initial call
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <section ref={sectionRef} id="trust-bar" className={styles.trustBar}>
      <div className={styles.marquee}>
        <div ref={trackRef} className={styles.marqueeTrack}>
          {trustItems.map((item, index) => {
            const parallaxOffset = scrollY * item.depth * 6
            return (
              <div
                key={index}
                className={styles.trustItem}
                style={{
                  transform: `translateY(${parallaxOffset}px)`,
                  transition: 'transform 0.1s ease-out'
                }}
              >
                <Dot />
                <span className={styles.text}>{item.text}</span>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default TrustBar
